/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * A merchant's static account, the one customers pay into at checkout
 */
export type MerchantStaticAccountRecord = {
    /**
     * The name a payer sees on name enquiry
     */
    accountName?: string;
    /**
     * The account number customers pay into
     */
    accountNumber?: string;
    /**
     * The bank holding the account
     */
    bankName?: string;
    /**
     * ACTIVE when the account accepts payments, INACTIVE when switched off
     */
    status?: MerchantStaticAccountRecord.status;
};

export namespace MerchantStaticAccountRecord {

    /**
     * ACTIVE when the account accepts payments, INACTIVE when switched off
     */
    export enum status {
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE',
        CREDITED = 'CREDITED',
        RECYCLED = 'RECYCLED',
    }


}
